module.exports = __webpack_public_path__ + "img/bj.b4523d16.png";